const Footer = () => {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target) as HTMLElement | null;
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-fill text-background-50 text-sm"></i>
              </span>
              <span className="font-heading font-bold text-background-50 text-base">吃瓜网每日大赛</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              全网最热吃瓜资讯聚合平台。提供吃瓜网入口与吃瓜网最新地址，安全直达，最新爆料与大赛视频尽在掌握。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-200 text-sm mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#updates" onClick={(e) => handleScroll(e, '#updates')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a>
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">吃瓜专题</a>
              <a href="#ranking" onClick={(e) => handleScroll(e, '#ranking')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a>
              <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-200 text-sm mb-4">内容板块</h4>
            <nav className="flex flex-col gap-2">
              <a href="#cards" onClick={(e) => handleScroll(e, '#cards')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">图文资讯</a>
              <a href="#media" onClick={(e) => handleScroll(e, '#media')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">视频速递</a>
              <a href="#carousel" onClick={(e) => handleScroll(e, '#carousel')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
              <a href="#topics" onClick={(e) => handleScroll(e, '#topics')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a>
              <a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">爆料投稿</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-200 text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">优质合作伙伴招募中</p>
            <div className="mt-4 flex gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-vidicon-line text-sm"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800">
          <p className="text-center text-xs text-background-500">
            &copy; {new Date().getFullYear()} 吃瓜网每日大赛官网 - 吃瓜网入口与吃瓜网最新地址。本站内容仅供娱乐参考，不构成任何投资或法律建议。
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;